/**
 * Página de Carrinho V6 — aprimoramento progressivo mínimo.
 *
 * O formulário nativo é a fonte de verdade: sem JavaScript, o input
 * numérico, o botão Atualizar, a remoção por link e o checkout funcionam
 * integralmente. Este script só adiciona:
 * - steppers +/− que alteram o input respeitando quantity_rule;
 * - destaque do botão "Atualizar carrinho" quando há alteração pendente.
 *
 * Sem Ajax, sem Cart API, sem fetch — o Ajax é exclusivo do drawer.
 */
(function () {
  'use strict';

  if (customElements.get('cart-page')) return;

  class CartPage extends HTMLElement {
    connectedCallback() {
      this.onClick = this.handleClick.bind(this);
      this.onInput = this.handleInput.bind(this);
      this.addEventListener('click', this.onClick);
      this.addEventListener('input', this.onInput);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      this.removeEventListener('input', this.onInput);
    }

    handleClick(event) {
      var button = event.target.closest('[data-page-qty-minus], [data-page-qty-plus]');
      if (!button || !this.contains(button)) return;

      var input = button.closest('.cart-line__quantity').querySelector('[data-page-qty-input]');
      if (!input) return;

      var direction = button.hasAttribute('data-page-qty-plus') ? 1 : -1;
      var min = parseInt(input.dataset.ruleMin, 10) || 1;
      var step = parseInt(input.dataset.ruleStep, 10) || 1;
      var max = input.dataset.ruleMax ? parseInt(input.dataset.ruleMax, 10) : Infinity;
      var value = parseInt(input.value, 10);
      if (isNaN(value)) value = min;

      value += direction * step;
      if (value < min) value = min;
      if (value > max) value = max;
      // alinha ao incremento a partir do mínimo
      value = min + Math.round((value - min) / step) * step;
      if (value > max) value -= step;
      if (value < min) value = min;

      if (String(value) !== input.value) {
        input.value = value;
        this.markPending();
      }
    }

    handleInput(event) {
      if (event.target.matches('[data-page-qty-input], [data-cart-note]')) {
        this.markPending();
      }
    }

    // Alteração pendente: destaca o Atualizar (a ação oficial continua o submit)
    markPending() {
      var update = this.querySelector('[data-cart-update]');
      if (update) update.classList.add('cart-page__update--attention');
    }
  }

  customElements.define('cart-page', CartPage);
})();
